import React, { useContext } from 'react';
import { usePageViewTracker } from '@ibinder/common-utils';
import { AdminBinderContext } from '../AdminLayout';
import { BINDER_COLOR } from '../placeholderData';
import styled from 'styled-components';
import {
  AnimatedDiv,
  BinderContent,
  ContainerWithColor
} from '@ibinder/common-frontend';
import RegisterHeader from './RegisterHeader';
import TabContent from './TabContent';
import { UserAccessBreadcrumbProvider } from './userAccessBreadcrumb';
import EditBinderTemplates from '../../../components/GlobalTemplates/EditBinderTemplates';
import { PrintProviderDetails } from '../../PrintProviders/pages/PrintProviderDetails';

const ExtendedBinderContent = styled(BinderContent)`
  height: 100%;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AnimatedDivMinWidth = styled(AnimatedDiv)`
  min-width: 0;
`;

const StyledContainerWithColor = styled(ContainerWithColor)`
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 10;
  border-top: 0.0625rem solid transparent;
`;

const Layout = styled.div`
  display: flex;
  margin: 0.75rem 1rem;
  height: calc(100% - 1.5rem);

  @media (max-width: ${(props) => props.theme.devices.md}px) {
    flex-direction: column;
  }
  @media (max-width: ${(props) => props.theme.devices.sm}px) {
    margin: 0.5rem;
    height: calc(100% - 1rem);
  }
`;

const AdminContentContainer = ({ nodeData, tabs, ...otherProps }) => {
  const { rightPanelOpen, toggleTabsMenu } = useContext(AdminBinderContext);

  usePageViewTracker(false, {
    name: 'AdminContent',
    pathname: location.pathname
  });
  const isBinderTemplateList = window.location.href.includes(
    'GlobalBinderTemplateList'
  );
  const isProviderDetails = window.location.href.includes('/provider/');

  return (
    <AnimatedDivMinWidth>
      <StyledContainerWithColor {...otherProps} color={BINDER_COLOR}>
        <Layout>
          <ExtendedBinderContent>
            <UserAccessBreadcrumbProvider>
              {!isBinderTemplateList && !isProviderDetails && (
                <RegisterHeader
                  tabs={tabs}
                  rightPanelOpen={rightPanelOpen}
                  toggleTabsMenu={toggleTabsMenu}
                  nodeData={nodeData}
                />
              )}
              {isBinderTemplateList && <EditBinderTemplates />}
              {isProviderDetails && (
                <PrintProviderDetails
                  rightPanelOpen={rightPanelOpen}
                  toggleTabsMenu={toggleTabsMenu}
                />
              )}
              <TabContent nodeData={nodeData} />
            </UserAccessBreadcrumbProvider>
          </ExtendedBinderContent>
        </Layout>
      </StyledContainerWithColor>
    </AnimatedDivMinWidth>
  );
};

export default AdminContentContainer;
